import { Stat, StatHelpText, StatLabel, StatNumber } from "@chakra-ui/react";
import { TokenBalanceDetails } from "../../types/tokens";

export default function InvestorBalance({
  vaultData,
  sourceTokenSymbol,
  targetTokenSymbol,
}: {
  vaultData: TokenBalanceDetails | undefined;
  sourceTokenSymbol: string | undefined;
  targetTokenSymbol: string | undefined;
}) {
  // TODO: TO BE IMPROVED
  return (
    <Stat>
      <StatLabel>Your Balance</StatLabel>
      {/* <StatHelpText fontSize="xs" mt="1em">
        You currently have
      </StatHelpText> */}
      <StatNumber fontSize="xl">
        {vaultData?.formatted}&nbsp;{vaultData?.symbol}
        {/* TODO: {_renderAmount(isLoading, isError, isSuccess, data, 6, vaultInfo.VAULT_DECIMALS)} */}
      </StatNumber>
      {/* <StatHelpText fontSize="sm">shares in this vault, worth</StatHelpText> */}

      {/* <StatNumber fontSize="sm">
        0&nbsp;{targetTokenSymbol}&nbsp;+&nbsp;0&nbsp;{sourceTokenSymbol}
        TODO: {_renderAmount(isLoading, isError, isSuccess, data, 7, vaultInfo.VAULT_ASSET_DECIMALS)}
      </StatNumber> */}

      {/* <StatHelpText mt="1em">
        (TODO: currentEpoch-startingEpoch epochs elapsed, startingEpoch+numEpochs-curentEpoch epochs left)
      </StatHelpText> */}
    </Stat>
  );
}
